import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

const ctaBg =
  'https://readdy.ai/api/search-image?query=Multiple%20pairs%20of%20premium%20sneakers%20arranged%20on%20a%20warm%20oak%20wooden%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20high%20detail%20warm%20neutral%20tones%20no%20text&width=1600&height=600&seq=cta-bg-01&orientation=landscape';

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={ctaBg}
          alt="AllChinaBuy Spreadsheet products"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-20 text-center md:px-6 md:py-28">
        <h2 className="font-heading text-3xl font-bold text-white md:text-4xl">
          {t('finalcta.title')}
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/70 md:text-base">
          {t('finalcta.subtitle')}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white px-8 py-4 text-sm font-semibold text-foreground-900 transition-colors hover:bg-background-100 cursor-pointer"
          >
            {t('finalcta.button1')}
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
          <Link
            to="/allchinabuy-spreadsheet-guide"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/40 px-8 py-4 text-sm font-semibold text-white transition-colors hover:bg-white/10 cursor-pointer"
          >
            {t('finalcta.button2')}
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}